import {ScreenPreferencesModel} from '../models/screen-preferences.model';
import { Injectable } from "@angular/core";

@Injectable()
export class ScreenPreferencesDefault {
    public screenPreferences: ScreenPreferencesModel = {
        showCompletedActions: true,
        barcodeTorchEnabled: false,
        selectedBarcodeDevice: null,
        selectedScannerFormats: []
    };
}
